import React, { ReactElement, useContext, useState } from "react";
import { authContext } from "../Context/Authentication/authContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./resetPassword.scss";
import {
  Button,
  IconButton,
  InputAdornment,
  OutlinedInput,
  FormControl,
  Typography,
  FormHelperText,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import credentials from "./Credentials.json";
import { Bars } from "react-loader-spinner";
import { generateDropDownRanges } from "../Helpers/helpers";
import { baseURL, dataScienceURL, otherBaseURL } from "../config";
import { error } from "console";

export default function ResetPassword(): ReactElement {
  const navigate = useNavigate();
  const { dispatch, state }: any = useContext(authContext);
  const [showError, setShowError] = useState(false);
  const [showEmptyError, setShowEmptyError] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [userPwd, setUserPwd] = useState("");
  const [userConfirmPwd, setUserConfirmPwd] = useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [errorMsg, setErrorMessage] = useState("");

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);
  const login = async () => {
    // setShowError(false);
    setLoading(true)
    if(email===""){
        setShowError(true);
        setErrorMessage("😕 Please fill out the empty fields")
        setLoading(false)
        return

    }
    const payload:any =   {
        "email": email.toLowerCase(),
      }
      const response = await axios.post(`${otherBaseURL}reset_password/initiate`,payload).then((response)=>{
        console.log(response)
        setShowConfirmation(true)
        setShowError(false)
        setLoading(false)


      }).catch((error)=>{
        console.log(response)
        setShowConfirmation(false)
        setShowError(true)
        setErrorMessage(`${error.response.data.message}`);
        setLoading(false)
      });
  
   
  };

  // const login = async () => {
  //   if (userName === "" || userPwd === "") {
  //     setShowError(true);
  //     return;
  //   }
  //   const user = credentials?.find(
  //     ({ username }) => username.toLowerCase() === userName.toLowerCase()
  //   );
  //   if (!user) {
  //     setShowError(true);
  //     return;
  //   }
  //   if (user?.password === userPwd) {
  //     setLoading(true);
  //     const predictionTill = await generateDropDownRanges();
  //     localStorage.setItem("isLoggedIn", JSON.stringify(true));
  //     localStorage.setItem("user", JSON.stringify(user));

  //     dispatch({
  //       type: "IS_AUTHENTICATED",
  //       payload: true,
  //     });
  //     dispatch({
  //       type: "SET_USER",
  //       payload: user,
  //     });
  //     dispatch({
  //       type: "APPLY_FILTER",
  //       payload: {
  //         ...state.filters,
  //         predictionTill,
  //       },
  //     });
  //     navigate("/");
  //   } else {
  //     setShowError(true);
  //   }
  // };

  const handleInputChange = (ev: any) => {
    if (ev.target.name === "firstName") {
      setShowError(false);
      setFirstName(ev.target.value);
    } else if (ev.target.name === "lastName") {
      setShowError(false);
      setLastName(ev.target.value);
    } else if (ev.target.name === "email") {
      setShowError(false);
      setEmail(ev.target.value);
    } else if (ev.target.name === "confirmPassword") {
      setShowError(false);
      setUserConfirmPwd(ev.target.value);
    } else {
      setShowError(false);
      setUserPwd(ev.target.value);
    }
  };

  const handleSignUp = () => {
     navigate('/login')
  };

  return (
    <div className="ftLogin">
      <div className="ftLogin_leftContainer">
        <div className={"ftLogin_leftContainer_text"}>
          <div className={"ftLogin_leftContainer_text_1"}>
            <b>Estate Intel 1.0</b>
          </div>
          <div className={"ftLogin_leftContainer_text_3"}>
            Building Bridges to the <b>future</b> through{" "}
            <b>smart technologies</b> and <b>smarter construction.</b>
          </div>
        </div>
      </div>
      <div>
        <div className={"ftLogin_container_parent1"}>
          <div className={"ftLogin_container_parent2"}>
            <div className="ftLogin_container">
              <form
                className="ftLogin_container_form"
                onSubmit={(ev) => {
                  ev.preventDefault();
                  login();
                }}
              >
                <FormControl
                  sx={{ m: 2, width: "95%" }}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Typography
                    className="ftLogin_container_form_resetHeading"
                    gutterBottom
                  >
                    Forgot your password?
                  </Typography>
                </FormControl>

                <FormControl
                  sx={{ m: 0, width: "95%" }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "12px",
                  }}
                >
                  <Typography
                    className="ftLogin_container_form_subHeading"
                    gutterBottom
                  >
                  {!showConfirmation?"Please enter the email linked to your Slate account":"If you have an account with Slate, you would have received an email to reset your password. If you're unable to find it, check your spam folder. If you still can't find it, click the button below to resend the email"}
                  </Typography>
                </FormControl>

                <FormControl sx={{ m: 2, width: "95%" }}>
                  <Typography
                    className="ftLogin_container_form_label"
                    gutterBottom
                  >
                    Email*
                  </Typography>
                  <OutlinedInput
                    className="ftLogin_container_form_input"
                    name="email"
                    value={email}
                    onChange={handleInputChange}
                  />
                </FormControl>
                {/* {
                  isSignUp && (
                    <>
                    <FormControl sx={{ m: 2, width: "95%" }}>
                    <Typography
                      className="ftLogin_container_form_label"
                      gutterBottom
                    >
                      FIrst Name
                    </Typography>
                    <OutlinedInput
                      className="ftLogin_container_form_input"
                      name="firstName"
                      value={firstName}
                      onChange={handleInputChange}
                    />
                  </FormControl><FormControl sx={{ m: 2, width: "95%" }}>
                    <Typography
                      className="ftLogin_container_form_label"
                      gutterBottom
                    >
                      Last Name
                    </Typography>
                    <OutlinedInput
                      className="ftLogin_container_form_input"
                      name="lastName"
                      value={lastName}
                      onChange={handleInputChange}
                    />
                  </FormControl>
                    </>
                  )
                } */}
                {/* <FormControl sx={{ m: 2, width: "95%" }}>
                  <Typography
                    gutterBottom
                    className="ftLogin_container_form_label"
                  >
                    Password
                  </Typography>

                  <OutlinedInput
                    className="ftLogin_container_form_input"
                    id="outlined-adornment-password"
                    type={showPassword ? "text" : "password"}
                    onChange={handleInputChange}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl> */}

                {/* {
                  isSignUp && (
                    <FormControl sx={{ m: 2, width: "95%" }}>
                    <Typography
                      gutterBottom
                      className="ftLogin_container_form_label"
                    >
                      Confirm Password
                    </Typography>
  
                    <OutlinedInput
                      className="ftLogin_container_form_input"
                      id="outlined-adornment-password"
                      type={showConfirmPassword ? "text" : "password"}
                      onChange={handleInputChange}
                      name="confirmPassword"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowConfirmPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  )
                // } */}

               
                  <Button
                    variant="outlined"
                    // onClick={() => login()}
                    type="submit"
                    className="ftLogin_container_form_resetButton"
                  >
                    {showConfirmation?"Resend Reset Link":"Send Reset Link"}
                    <Bars
                      height="30"
                      color="#035F77"
                      ariaLabel="bars-loading"
                      wrapperStyle={{ float: "left" }}
                      wrapperClass=""
                      visible={loading}
                    />
                  </Button>
                <div className="ftLogin_container_form_signup">
                  <FormControl sx={{ m: 1 }}>
                    <FormHelperText
                      id="accountId-error"
                      onClick={handleSignUp}
                      className="ftLogin_container_form_signup_signuptext"
                    >
                      Back to Login
                    </FormHelperText>
                  </FormControl>
                  {/* {
                !isSignUp && (
                  <FormControl sx={{ m: 1 }} style={{marginLeft:'12px'}}>
                  <FormHelperText  id="accountId-error" className="ftLogin_container_form_signup_forgotpassword" >
                          Forgot Password?
                        </FormHelperText>
                  </FormControl>
                )
              } */}
                </div>

                {/* {showConfirmation && (
                  <div className="errorContainer">
                    <FormControl sx={{ m: 1 }}>
                      <FormHelperText id="accountId-error">
                        User Registered Succesfully!
                      </FormHelperText>
                    </FormControl>
                  </div>
                )} */}

                {showError && (
                  <div className="errorContainer">
                    <FormControl sx={{ m: 1 }}>
                      <FormHelperText error id="accountId-error">
                        {errorMsg}
                        {/* {isSignUp?showEmptyError?"😕 Please fill out the empty fields ":"😕 Username/Email already exists":"😕 Username/password is incorrect"} */}
                      </FormHelperText>
                    </FormControl>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
